'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconChannels = function IconChannels(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M3.79775281,4.95321633 L3.79775281,15.3150584 L6.72089888,15.3150584 C7.21797753,15.3150584 7.61977528,15.7295321 7.61977528,16.2361111 L7.61977528,17.7834795 L10.4305618,15.5084795 C10.588764,15.3795321 10.785618,15.3150584 10.9869663,15.3150584 L20.2022472,15.3150584 L20.2022472,4.95321633 L3.79775281,4.95321633 Z M6.72089888,20.6111111 C6.58786517,20.6111111 6.45393258,20.5834795 6.32988764,20.5190058 C6.0188764,20.3624269 5.82202247,20.0400584 5.82202247,19.6900584 L5.82202247,17.1571637 L3.79775281,17.1571637 C2.80808989,17.1571637 2,16.3282163 2,15.3150584 L2,4.95321633 C2,3.94005843 2.80808989,3.11111106 3.79775281,3.11111106 L20.2022472,3.11111106 C21.1946067,3.11111106 22,3.94005843 22,4.95321633 L22,15.3150584 C22,16.3282163 21.1946067,17.1571637 20.2022472,17.1571637 L11.2997753,17.1571637 L7.27910112,20.4084795 C7.11820225,20.5466374 6.91955056,20.6111111 6.72089888,20.6111111 L6.72089888,20.6111111 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M17.4444444,8.68888884 L7.44444444,8.68888884 C7.2,8.68888884 7,8.49333329 7,8.2444444 C7,7.99555551 7.2,7.79999995 7.44444444,7.79999995 L17.4444444,7.79999995 C17.6915556,7.79999995 17.8888889,7.99555551 17.8888889,8.2444444 C17.8888889,8.49333329 17.6915556,8.68888884 17.4444444,8.68888884', id: 'Fill-241' }),
      ' ',
      _react2.default.createElement('path', { d: 'M17.4444444,12.0222222 L7.44444444,12.0222222 C7.2,12.0222222 7,11.8266666 7,11.5777777 C7,11.3377777 7.2,11.1333333 7.44444444,11.1333333 L17.4444444,11.1333333 C17.6915556,11.1333333 17.8888889,11.3377777 17.8888889,11.5777777 C17.8888889,11.8266666 17.6915556,12.0222222 17.4444444,12.0222222' }),
      ' '
    )
  );
};

IconChannels.propTypes = {
  color: _propTypes2.default.string
};

IconChannels.defaultProps = {
  color: _colors2.default.icons
};

IconChannels.displayName = 'IconChannels';

exports.default = IconChannels;
module.exports = exports.default;